module.exports = __webpack_public_path__ + "img/notice.6c8ec25b.png";